const reportEfficiencyLeadhitModule = {
  state: {
    items: null,
  },
  mutations: {
    setEfficiencyLeadhitOrders (state, data) {
      state.items = data
    },
  },
  getters: {
    getEfficiencyLeadhitOrders: (state) => {
      return state.items
    },
  }
}

export default reportEfficiencyLeadhitModule



// WEBPACK FOOTER //
// ./src/store/modules/report_efficiency_leadhit.js